import { useEffect } from 'react';

import {
  DeviceOfferDetail,
  PaymentOption,
} from 'journey/productDetails/typings';
import { trackExistingPlanSelector } from './trackExistingPlanSelector';

export default function useTrackExistingPlanSelectorActionLayer({
  numberOfEligiblePlansForIFP,
  device,
  paymentOption,
}: {
  numberOfEligiblePlansForIFP: number;
  device: DeviceOfferDetail;
  paymentOption: PaymentOption;
}) {
  useEffect(() => {
    trackExistingPlanSelector({
      numberOfEligiblePlansForIFP,
      device,
      paymentOption,
    });
  }, []);
}
